import type { SwipeMapDataset } from './types';

export const initialSwipeMapDatasetState: SwipeMapDataset = {
  leftIteration: null,
  rightIteration: null,
};
